/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SavingsPlanRecommendationsRequest {
    getFixupPrototypeFunction() { return SavingsPlanRecommendationsRequest.fixupPrototype; }

    static newInstance(model: Partial<SavingsPlanRecommendationsRequest>): SavingsPlanRecommendationsRequest {
        let obj = Object.assign(new SavingsPlanRecommendationsRequest(), model);
        SavingsPlanRecommendationsRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SavingsPlanRecommendationsRequest>): SavingsPlanRecommendationsRequest {
        if (!model) return null;
        return SavingsPlanRecommendationsRequest.newInstance(<SavingsPlanRecommendationsRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SavingsPlanRecommendationsRequest) {
        if (!obj) return;

        models.SavingsPlanRecommendationsRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SavingsPlanRecommendationsRequest): boolean {
        Object.setPrototypeOf(obj, SavingsPlanRecommendationsRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * One or more tenant IDs to fetch savings plan recommendations across.
     */
    tenant_ids: Array<string>;

}
